import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as licenseManagerActions from '../../../../redux/css-admin/licenseManager/actions'
import * as licenseManagerOperations from '../../../../redux/css-admin/licenseManager/operations'
import { clearUsers } from '../../../../redux/css-admin/userManager/actions'
import { Row, Col, Button, Input, Label } from 'reactstrap'
import ErrorBoundary from 'components/ErrorBoundary'
import SelectLookup from '../../../../components/SelectLookup'
import { formatUserSuggestion } from '../../../../lib/util'

class SearchForm extends Component {
  static propTypes = {
    clearLicenses: PropTypes.func,
    clearSearch: PropTypes.func.isRequired,
    clearUsers: PropTypes.func,
    criteria: PropTypes.object.isRequired,
    search: PropTypes.func.isRequired,
    searchLicensesAndHandle: PropTypes.func.isRequired,
    updateCriteria: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { clearLicenses, clearUsers } = this.props
    clearLicenses()
    clearUsers()
  }

  render() {
    const {
      clearSearch,
      criteria,
      search,
      searchLicensesAndHandle,
      updateCriteria,
    } = this.props
    const handleChange = e => updateCriteria(e.target.name, e.target.value)

    const handleSelectChange = (name, selection) => {
      if (selection != null && searchLicensesAndHandle) {
        searchLicensesAndHandle({
          key: name,
          value: selection.value,
        })
      }
    }

    const handleKeydown = e => {
      if (e.keyCode === 13) {
        search()
      }
    }

    return (
      <ErrorBoundary>
        <Row>
          <Col md={12} sm={12}>
            <fieldset>
              <div
                className="form-group"
                data-testid="setupAdminEmail-search-form"
              >
                <Label>Setup Admin (Email)</Label>
                <SelectLookup
                  apiVersion={2}
                  formatSuggestion={formatUserSuggestion}
                  onChange={selection =>
                    handleSelectChange('setupAdminEmail', selection)
                  }
                  placeholder={'Setup Admin Email'}
                  searchEndpoint="profile/search"
                  searchField="email"
                  value={
                    null
                  } /* Value left null on purpose because 
                  we always ignore the email field when searching
                  with other fields */
                />
              </div>
              <div
                className="form-group"
                data-testid="nsSubscriptionId-search-form"
              >
                <Label>NS Subscription Id</Label>
                <input
                  className="form-control"
                  name="nsSubscriptionId"
                  onChange={handleChange}
                  onKeyDown={handleKeydown}
                  type="text"
                  value={criteria.nsSubscriptionId || ''}
                />
              </div>
              <div
                className="form-group"
                data-testid="ssSubscriptionId-search-form"
              >
                <Label>SS Subscription Id</Label>
                <input
                  className="form-control"
                  name="subscriptionId"
                  onChange={handleChange}
                  onKeyDown={handleKeydown}
                  type="number"
                  value={criteria.subscriptionId || ''}
                />
              </div>
              <div className="form-group" data-testid="nsLicenseId-search-form">
                <Label>NS License Id</Label>
                <input
                  className="form-control"
                  name="nsLicenseId"
                  onChange={handleChange}
                  onKeyDown={handleKeydown}
                  type="text"
                  value={criteria.nsLicenseId || ''}
                />
              </div>
              <div className="form-group" data-testid="ssLicenseId-search-form">
                <Label>SS License Id</Label>
                <input
                  className="form-control"
                  name="licenseId"
                  onChange={handleChange}
                  onKeyDown={handleKeydown}
                  type="number"
                  value={criteria.licenseId || ''}
                />
              </div>
            </fieldset>
          </Col>
        </Row>

        <hr />
        <div className="text-right">
          <Button
            className="btn-fixed-width"
            color="link"
            data-testid="clear-button"
            onClick={clearSearch}
          >
            Clear
          </Button>
          <Button
            className="btn-fixed-width"
            color="primary"
            data-testid="search-button"
            disabled={criteria.size === 0}
            onClick={search}
          >
            <i className="fas fa-search" />
            &nbsp;Search
          </Button>
        </div>
      </ErrorBoundary>
    )
  }
}

const mapDispatchToProps = {
  ...licenseManagerActions,
  ...licenseManagerOperations,
  clearUsers: clearUsers,
}

export default connect(null, mapDispatchToProps)(SearchForm)



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/search/SearchForm.js